export const PROFESSIONAL_LIABILITY_DESCRIPTION =
  "Confirm contractors are protected against professional mistakes with E&O insurance verification. The system automatically checks their policy documents to ensure coverage for claims of negligence or failure to deliver services.";
export const PROFESSIONAL_LIABILITY_EXAMPLE_USE_CASES =
  "Protection against claims of financial loss caused by a contractor's professional mistakes.";
export const PROFESSIONAL_LIABILITY_COST = "$1.99 per verification";

export const PROFESSIONAL_LIABILITY = {
  description: PROFESSIONAL_LIABILITY_DESCRIPTION,
  exampleUseCases: PROFESSIONAL_LIABILITY_EXAMPLE_USE_CASES,
  cost: PROFESSIONAL_LIABILITY_COST
};
